<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="kl8Form" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="起始期数">
        <el-input v-model="queryParams.startPeriod" placeholder="开始期数" clearable style="width: 100px;"/>
        -
        <el-input v-model="queryParams.endPeriod" placeholder="结束期数" clearable style="width: 100px;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryKl8">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQueryKl8">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:init']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleInitAllKl8">全部初始化
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:fill']" type="primary" plain icon="el-icon-refresh-right" size="mini" @click="handleFillKl8History">
          补全历史数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:count']" type="danger" plain icon="el-icon-data-line" size="mini" @click="handleKl8DataLine">号码频率
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:export']" type="warning" plain icon="el-icon-export" size="mini" @click="handleExportKl8">导出</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:initC']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleInitAllKl8C">
          初始化统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:exportC']" type="warning" plain icon="el-icon-export" size="mini" @click="handleOpenC()">导出统计数据
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:cache']" type="danger" plain icon="el-icon-export" size="mini" @click="handleRefreshKl8">刷新缓存</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:gen']" type="success" plain icon="el-icon-refresh-left" size="mini" @click="handleOpenGenerateKl8">
          生成快乐8
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['lottery:kl8:exportF']" type="warning" plain icon="el-icon-export" size="mini" @click="exportFrequency">导出组合频率
        </el-button>
      </el-col>
      <right-toolbar :show-search.sync="showSearch" @queryTable="getKl8List" />
    </el-row>
    <el-table :data="kl8List" v-loading="loading" border highlight-current-row
              :cell-class-name="cellClassName">
      <el-table-column label="期号" align="center" prop="period"/>
      <el-table-column label="中奖号码" align="center">
        <el-table-column label="1" align="center" prop="num1" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num1)">
              {{ scope.row.num1 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="2" align="center" prop="num2" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num2)">
              {{ scope.row.num2 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="3" align="center" prop="num3" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num3)">
              {{ scope.row.num3 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="4" align="center" prop="num4" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num4)">
              {{ scope.row.num4 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="5" align="center" prop="num5" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num5)">
              {{ scope.row.num5 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="6" align="center" prop="num6" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num6)">
              {{ scope.row.num6 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="7" align="center" prop="num7" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num7)">
              {{ scope.row.num7 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="8" align="center" prop="num8" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num8)">
              {{ scope.row.num8 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="9" align="center" prop="num9" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num9)">
              {{ scope.row.num9 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="10" align="center" prop="num10" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num10)">
              {{ scope.row.num10 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="11" align="center" prop="num11" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num11)">
              {{ scope.row.num11 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="12" align="center" prop="num12" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num12)">
              {{ scope.row.num12 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="13" align="center" prop="num13" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num13)">
              {{ scope.row.num13 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="14" align="center" prop="num14" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num14)">
              {{ scope.row.num14 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="15" align="center" prop="num15" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num15)">
              {{ scope.row.num15 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="16" align="center" prop="num16" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num16)">
              {{ scope.row.num16 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="17" align="center" prop="num17" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num17)">
              {{ scope.row.num17 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="18" align="center" prop="num18" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num18)">
              {{ scope.row.num18 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="19" align="center" prop="num19" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num19)">
              {{ scope.row.num19 }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="20" align="center" prop="num20" width="40">
          <template slot-scope="scope">
            <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num20)">
              {{ scope.row.num20 }}
            </el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="奖池金额" align="right" prop="pondAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatMoney(scope.row.pondAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="销售金额" align="right" prop="saleAmount" min-width="100px">
        <template slot-scope="scope">
          {{ formatYuan(scope.row.saleAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="开奖日期" align="center" prop="lotteryDate" min-width="90px">
        <template slot-scope="scope">
          {{ scope.row.lotteryDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150px">
        <template slot-scope="scope">
          <el-button v-hasPermi="['lottery:kl8:win']" type="text" icon="el-icon-medal" @click="handleNextHistory(scope.row.period)">下期</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getKl8List"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
    />
    <!-- 数字次数图表弹出层 -->
    <el-dialog :title="countTitle" :visible.sync="countOpen" width="1500px" @closed="countClosed"
               :close-on-click-modal="false">
      <div ref="redChart" style="width:100%;height: 500px;"></div>
    </el-dialog>
    <!-- 导出统计次数弹出层 -->
    <el-dialog :title="cTitle" :visible.sync="cOpen" width="300px" :close-on-click-modal="false">
      <el-form ref="cForm" :model="cForm" :rules="cRules" label-width="110px" label-suffix="：">
        <el-form-item prop="isC">
                    <span slot="label">
                      是否排序
                      <el-popover
                        placement="top-start"
                        width="250"
                        trigger="hover"
                        content="如果排序为是，导出数据号码为历史出现次数从多到少的顺序;否则按照数据号码从小到大排序">
                        <i slot="reference" class="el-icon-question"></i>
                      </el-popover>
                    </span>
          <el-select v-model="cForm.isC" placeholder="请选择是否" style="width: 140px">
            <el-option :key="true" label="是" :value="true"></el-option>
            <el-option :key="false" label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportC">导出</el-button>
        <el-button @click="cancelC">取消</el-button>
      </div>
    </el-dialog>
    <!-- 生成快乐8弹出层 -->
    <el-dialog title="生成快乐8" :visible.sync="generateKl8Open" width="640px" :close-on-click-modal="false">
      <el-form ref="generateKl8Form" :model="generateKl8Form" :inline="true" :rules="generateKl8Rules"
               label-width="80px">
        <el-form-item label="生成个数" prop="count">
          <el-select v-model="generateKl8Form.count" placeholder="请选择个数">
            <el-option :key="1" label="1" :value="1"/>
            <el-option :key="5" label="5" :value="5"/>
            <el-option :key="10" label="10" :value="10"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleGenerateKl8">生成</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetGenerateKl8">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="generateKl8List" border style="width: 100%" :cell-class-name="cellClassName"
                highlight-current-row>
        <el-table-column label="号码" align="center">
          <el-table-column label="1" align="center" prop="num1" width="50"/>
          <el-table-column label="2" align="center" prop="num2" width="50"/>
          <el-table-column label="3" align="center" prop="num3" width="50"/>
          <el-table-column label="4" align="center" prop="num4" width="50"/>
          <el-table-column label="5" align="center" prop="num5" width="50"/>
          <el-table-column label="6" align="center" prop="num6" width="50"/>
          <el-table-column label="7" align="center" prop="num7" width="50"/>
          <el-table-column label="8" align="center" prop="num8" width="50"/>
          <el-table-column label="9" align="center" prop="num9" width="50"/>
          <el-table-column label="10" align="center" prop="num10" width="50"/>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-hasPermi="['lottery:kl8:win']" type="text" icon="el-icon-data-analysis" @click="handleWinning(scope.row)">概率</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期中奖概率弹出层 -->
    <el-dialog title="往期中奖概率" :visible.sync="winningOpen" width="500px">
      <el-row :gutter="20" v-for="(item,index) in winningList" :key="index" style="padding: 5px 0">
        <el-col :span="8">{{ item.name }}</el-col>
        <el-col :span="8">注数：{{ item.count }}</el-col>
        <el-col :span="8">概率：{{ formatMoney(item.winningRate * 100, 2) }}%</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="winningOpen=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 往期号码排序弹出层 -->
    <el-dialog title="往期号码排序" :visible.sync="numSortOpen" width="500px">
      <el-row :gutter="20" style="padding: 5px 0">
        <el-col :span="8" v-for="(item,index) in numSortList" :key="index">
          <span style="font-weight: bold;color: #FF0000" v-if="currNum===item.num">{{ index + 1 }}.</span><span
          style="font-weight: bold;" v-else>{{ index + 1 }}.</span>
          <span style="color: #FF0000" v-if="currNum===item.num">{{ item.num }}：</span><span
          v-else>{{ item.num }}：</span>
          <span style="color: #FF0000" v-if="currNum===item.num">{{ item.counts }}</span><span
          v-else>{{ item.counts }}：</span>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="numSortOpen=false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 下期快乐8同期历史数据弹出层 -->
    <el-dialog :title="kl8HistoryTitle" :visible.sync="kl8HistoryOpen" width="950px" :close-on-click-modal="false">
      <el-tabs v-model="activeKl8HistoryName" type="border-card">
        <el-tab-pane label="历史同期数据" name="firstKl8">
          <el-table :data="kl8HistoryList" border style="width: 100%" :cell-class-name="cellClassName"
                    highlight-current-row>
            <el-table-column label="期数" align="center" prop="period" width="70"/>
            <el-table-column label="中奖号码" align="center">
              <el-table-column label="1" align="center" prop="num1" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num1)">
                    {{ scope.row.num1 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="2" align="center" prop="num2" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num2)">
                    {{ scope.row.num2 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="3" align="center" prop="num3" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num3)">
                    {{ scope.row.num3 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="4" align="center" prop="num4" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num4)">
                    {{ scope.row.num4 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="5" align="center" prop="num5" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num5)">
                    {{ scope.row.num5 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="6" align="center" prop="num6" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num6)">
                    {{ scope.row.num6 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="7" align="center" prop="num7" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num7)">
                    {{ scope.row.num7 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="8" align="center" prop="num8" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num8)">
                    {{ scope.row.num8 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="9" align="center" prop="num9" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num9)">
                    {{ scope.row.num9 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="10" align="center" prop="num10" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num10)">
                    {{ scope.row.num10 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="11" align="center" prop="num11" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num11)">
                    {{ scope.row.num11 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="12" align="center" prop="num12" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num12)">
                    {{ scope.row.num12 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="13" align="center" prop="num13" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num13)">
                    {{ scope.row.num13 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="14" align="center" prop="num14" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num14)">
                    {{ scope.row.num14 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="15" align="center" prop="num15" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num15)">
                    {{ scope.row.num15 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="16" align="center" prop="num16" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num16)">
                    {{ scope.row.num16 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="17" align="center" prop="num17" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num17)">
                    {{ scope.row.num17 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="18" align="center" prop="num18" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num18)">
                    {{ scope.row.num18 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="19" align="center" prop="num19" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num19)">
                    {{ scope.row.num19 }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="20" align="center" prop="num20" width="40">
                <template slot-scope="scope">
                  <el-button type="text" class="red-ball" @click="handleSort(scope.row.period,scope.row.num20)">
                    {{ scope.row.num20 }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="统计数据" name="secondKl8">
          <el-row :gutter="10">
            <el-col :span="3" style="text-align: right">号码次数排名：</el-col>
            <el-col :span="21">
              <el-row :gutter="10">
                <el-col v-for="(item,index) in kl8HistoryNumList" :key="item.num" :span="3"><span
                  style="font-weight: bold">{{ index + 1 }}.</span> <span style="color: #d73a49">{{ item.num }}</span>
                  ({{ item.counts }}次)
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="3" style="text-align: right">未出现的号码：</el-col>
            <el-col :span="21"><span v-for="item in kl8HistoryNumZeroList" :key="item">{{ item }} </span></el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="kl8HistoryOpen=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  listKl8,
  initAllKl8,
  fillHistoryData,
  getKl8NumData,
  initAllKl8C,
  refreshKl8Cache,
  generateKl8,
  getNumSort,
  getNextKl8History,
  getKl8WinningData
} from '@/api/lottery/kl8'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      // 遮罩层
      loading: '',
      showSearch:true,
      //快乐8数据
      kl8List: [],
      // 快乐8数量
      total: 0,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        startPeriod: null,
        endPeriod: null
      },
      countTitle: '',
      countOpen: false,
      redChart: {},
      cTitle: '',
      cOpen: false,
      cForm: {},
      cRules: {
        isC: [
          {required: true, message: '是否不能为空', trigger: 'blur'}
        ]
      },
      generateKl8Open: false,
      generateKl8Form: {
        count: 1
      },
      generateKl8Rules: {
        count: [
          {required: true, message: '个数不能为空', trigger: 'blur'}
        ]
      },
      generateKl8List: [],
      numSortList: [],
      numSortOpen: false,
      currNum: null,
      winningList: [],
      winningOpen: false,

      activeKl8HistoryName: 'firstKl8',
      kl8HistoryOpen: false,
      kl8HistoryTitle: '',
      kl8HistoryList: [],
      kl8HistoryNumList: [],
      kl8HistoryNumZeroList: [],
    }
  },
  created() {
    this.getKl8List()
  },
  methods: {
    cellClassName({row, column, rowIndex, columnIndex}) {
      if (column.property) {
        if (column.property.startsWith('num')) {
          return 'red-ball';
        }
      }
    },
    /** 查询快乐8列表 */
    getKl8List() {
      listKl8(this.queryParams).then(res => {
        this.kl8List = res.rows;
        this.total = res.total
      })
    },
    /** 搜索快乐8列表 **/
    handleQueryKl8() {
      this.queryParams.current = 1;
      this.getKl8List()
    },
    /** 重置快乐8按钮操作 */
    resetQueryKl8() {
      this.queryParams.startPeriod = undefined;
      this.queryParams.endPeriod = undefined;
      this.resetForm("kl8Form");
      this.handleQueryKl8();
    },
    /** 初始化快乐8数据 **/
    handleInitAllKl8() {
      this.$modal.confirm("确定要初始化全部快乐8数据吗？确认后将全部重新生成！").then(action => {
        if (action === 'confirm') {
        this.$modal.loading("正在初始化中，请稍后...")
          initAllKl8().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryKl8();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },
    /** 补全快乐8历史数据 **/
    handleFillKl8History() {
      this.$modal.confirm("确定要补全快乐8历史数据吗？").then(action => {
        if (action === 'confirm') {
          this.$modal.loading("正在补全中，请稍后...")
          fillHistoryData().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("补全成功")
            this.handleQueryKl8();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=> {})
    },
    /** 快乐8数据统计柱状图 **/
    handleKl8DataLine() {
      this.countTitle = "快乐8数据统计柱状图";
      getKl8NumData().then(res => {
        if (res.data.length > 0) {
          let seriesData = res.data.map(item => item.counts);
          let xAxisData = res.data.map(item => item.num);
          this.redChart = echarts.init(this.$refs.redChart, "macarons");
          this.redChart.setOption({
            title: {
              text: '数据统计',
              left: 'center'
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross"
              }
            },
            color: ["#ff3c00"],
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "10%",
              containLabel: true
            },
            xAxis: {
              data: xAxisData
            },
            yAxis: {},
            series: [
              {
                name: "次数",
                type: "bar",
                data: seriesData,
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (data) {
                    return data.value
                  }
                }
              }
            ]
          });
        }
      })
      this.countOpen = true;
    },
    /** 导出大快乐8按钮操作 */
    handleExportKl8() {
      this.download('/admin/lottery/kl8/export', {
        ...this.queryParams
      }, `快乐8导出_${new Date().getTime()}.xlsx`)
    },

    /** 初始化快乐8统计数据 **/
    handleInitAllKl8C() {
      this.$modal.confirm("确定要初始化快乐8统计数据吗？").then(action => {
        if(action === 'confirm'){
          this.$modal.loading("正在初始化中，请稍后...")
          initAllKl8C().then(res => {
            this.$modal.closeLoading()
            this.$modal.msgSuccess("初始化成功")
            this.handleQueryKl8();
          }).catch(()=>{
            this.$modal.closeLoading()
          })
        }
      }).catch(()=>{ })
    },
    /** 刷新快乐8缓存 **/
    handleRefreshKl8() {
      refreshKl8Cache().then(() => {
        this.$modal.msgSuccess("刷新成功");
      })
    },
    /** 打开生成快乐8弹窗 */
    handleOpenGenerateKl8() {
      this.generateKl8Open = true;
      this.$set(this.generateKl8Form, 'count', 1)
      this.resetForm("generateKl8Form");
      this.generateKl8List = []
    },
    handleGenerateKl8() {
      this.$refs["generateKl8Form"].validate(valid => {
        if (valid) {
          generateKl8(this.generateKl8Form).then(res => {
            if (res.flag) {
              this.generateKl8List = res.data
            }
          })
        }
      })
    },
    resetGenerateKl8() {
      this.generateKl8List = []
      this.$set(this.generateKl8Form, 'count', 1)
      this.resetForm("generateKl8Form");
    },
    /** 获奖概率弹窗 **/
    handleWinning(row) {
      this.winningList = [];
      let queryParams = {
        num1: row.num1,
        num2: row.num2,
        num3: row.num3,
        num4: row.num4,
        num5: row.num5,
        num6: row.num6,
        num7: row.num7,
        num8: row.num8,
        num9: row.num9,
        num10: row.num10,
        period: row.period
      }
      getKl8WinningData(queryParams).then(res => {
        this.winningList = res.data
        this.winningOpen = true;
      })
    },
    /** 获奖概率弹窗 **/
    handleSort(period, num) {
      this.currNum = num;
      this.numSortList = [];
      let queryParams = {
        period: period,
        num: num
      }
      getNumSort(queryParams).then(res => {
        this.numSortList = res.data
        this.numSortOpen = true;
      })
    },
    /** 下期历史同期数据 **/
    handleNextHistory(period) {
      this.kl8HistoryList = [];
      this.kl8HistoryNumList = [];
      this.kl8HistoryNumZeroList = [];
      getNextKl8History(period).then(res => {
        this.kl8HistoryList = res.data.lotteryDataList;
        this.kl8HistoryNumList = res.data.numList;
        this.kl8HistoryNumZeroList = res.data.numZeroList;
        this.kl8HistoryTitle = "【" + res.data.period + "】期快乐8历史同期统计";
        this.kl8HistoryOpen = true;
      })
    },
    /** 打开导出彩票统计次数弹窗 **/
    handleOpenC() {
      this.cOpen = true;
      this.cTitle = "快乐8统计数据导出";
    },
    /** 导出统计次数 **/
    exportC() {
      this.$refs["cForm"].validate(valid => {
        if (valid) {
          this.download('/admin/lottery/kl8/exportC', {
            ...this.cForm
          }, `快乐8统计数据导出_${new Date().getTime()}.xlsx`)
        }
      });
    },
    cancelC() {
      this.cOpen = false;
      this.cForm = {};
      this.resetForm("cForm");
    },
    countClosed() {
      this.redChart.dispose();
    },
    close() {
      this.generateKl8Open = false;
    },
    exportFrequency() {
      this.download('/admin/lottery/kl8/exportFrequency', {
        ...this.queryParams
      }, `快乐8数字组合频率导出_${new Date().getTime()}.xlsx`)
    },
  }
}
</script>

